/* global $ */

import Awesomplete from 'awesomplete';
import debounce from '../helpers/debounce';

const KEY_LEFT = 37;
const KEY_RIGHT = 39;
const KEY_DOWN = 40;
const KEY_UP = 38;
const KEY_SHIFT = 16;
const KEY_ENTER = 13;

const DEBOUNCE_LENGTH = 150;

const IGNORED_KEYS = [KEY_UP, KEY_DOWN, KEY_RIGHT, KEY_LEFT, KEY_SHIFT, KEY_ENTER];

const renderItem = (label, category = null) => {
  const item = $('<li>', {
    html: label,
    'data-group': category,
    'aria-selected': 'false',
    class: 'awesomplete__item',
  })[0];

  return item;
};

const getSearch = (api, query, cb) => {
  $.ajax({
    url: `${api}`,
    data: {
      value: query,
    },
    type: 'POST',
    dataType: 'json',
    success: (data) => {
      cb.call(this, data);
    },
  });
};

const autocompleteSearch = {
  /**
   * Initialize dynamic list
   * @param {Node} container Container node
   * @return {Void}
   */
  create(container, props) {
    if (container.className.indexOf('is-initialized') >= 0) {
      return;
    }

    this.props = props;
    this.container = container;

    this.container.className += ' is-initialized';

    const awesompleteInst = new Awesomplete(this.container, {
      maxItems: 24,

      // The list will come from the server, so leave it empty for now
      list: [],

      /**
       * Filter the items based on the user input, we will always return true, because
       * the data is already filtered on the server
       * @param  {Object} text  Data from the API
       * @param  {String} input User input
       * @return {Boolean}      True if it should pass, and false if not
       */
      filter: () => true,

      /**
       * Sort on the group/category
       * @param  {Object} a Item to compare to b
       * @param  {Object} b Item to compare to a
       * @return {Number}   What the sort should do
       */
      // sort: function sort(a, b) {
      //   if (a.label > b.label) {
      //     return -1;
      //   }

      //   if (a.label < b.label) {
      //     return 1;
      //   }

      //   return 0;
      // },

      /**
       * Render item with data
       * @param  {Object} text  Data to show
       * @param  {String} input User input
       * @return {Node}         Node that will render to the DOM
       */
      item: (text, input) => {
        const html = (input === '')
          ? text
          : text.replace(RegExp(input.trim(), 'gi'), '<mark>$&</mark>');

        const cat = text.value.group;

        return renderItem(html, cat);
      },

      /**
       * Rewrite data stream to Awesomplete data object
       * @param  {Object} item Object from the API
       * @return {Object}      Awesomplete compatible data object
       */
      data: (item) => {
        const obj = {
          label: item.title,
          value: item,
        };

        return obj;
      },

      replace: (text) => {
        const key = this.props.autocompleteKey !== undefined ? this.props.autocompleteKey : 'title';
        const val = text.value[key];
        const outputElement = this.props.autocompleteOutput !== undefined
          ? document.getElementById(this.props.autocompleteOutput)
          : null;

        $(this.container).val(text.label);

        if (outputElement) {
          outputElement.value = val;
        }

        this.list = [];
      },
    });

    // Add a slight debounce, to not overflow the server, and have crossing requests
    const searchDebounced = debounce(getSearch, DEBOUNCE_LENGTH);

    // Listen for keyups on the input field, and request new items
    $(this.container).on('keyup', (e) => {
      if (IGNORED_KEYS.indexOf(e.keyCode) >= 0) {
        return true;
      }

      searchDebounced(this.props.autocompleteApi, e.currentTarget.value, (data) => {
        // Apply the list to Awesomplete
        awesompleteInst.list = data;

        // Reevaluate the items and suggestions
        awesompleteInst.evaluate();
      });

      return true;
    });
  },
};

export default autocompleteSearch;
